import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { getPrivacy } from '../../actions/applicationData';
import { updateAppState } from '../../actions/applicationState';
import { logout } from '../../actions/user';

import Body from '../../components/Body';
import DashboardHeader from '../../components/DashboardHeader';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';

class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
  }

  componentWillMount() {
    // Skip API calls during react-snap pre-rendering
    if (navigator.userAgent === 'ReactSnap') {
      this.setState({
        loaded: true,
        privacy: { content: '<p>Loading privacy policy...</p>' },
      });
      return;
    }

    this.fetchPrivacy();
  }

  getContent() {
    return {
      __html: this.state.privacy.content, // eslint-disable-line
    };
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(
      updateAppState({
        login_modal_open: true,
      }),
    );
  }

  fetchPrivacy() {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(getPrivacy()).then(
          response => {
            this.setState({
              privacy: response,
              loaded: true,
            });

            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
          err => {
            console.log(err); // eslint-disable-line no-console
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
            this.props.history.push('/404');
          },
        );
      });
  }

  render() {
    /* eslint-disable react/no-danger */
    return (
      <Body hasFooter>
        <SEO
          title="Privacy Policy"
          description={
            'Learn how The Dog Share Collective protects your privacy and handles your personal ' +
            'information. Read our comprehensive privacy policy.'
          }
          keywords="privacy policy, data protection, personal information, dog sharing privacy"
          url="https://www.thedogsharecollective.com/privacy"
        />
        {this.props.user.isAuthenticated ? (
          <DashboardHeader
            logoutHandler={this.logoutHandler}
            redirectHandler={this.redirectHandler}
            {...this.props}
          />
        ) : (
          <UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />
        )}
        <div className={css(styles.page_container)}>
          <div className={css(styles.heading_section)}>
            <h1 className={css(styles.heading)}>Privacy Policy</h1>
          </div>

          <div className={css(styles.content)}>
            {this.state.privacy ? (
              <div className={css(styles.container)} dangerouslySetInnerHTML={this.getContent()} />
            ) : null}
          </div>
        </div>
        <Footer user={this.props.user} />
      </Body>
    );
    /* eslint-enable react/no-danger */
  }
}

Privacy.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  page_container: {
    backgroundColor: Theme.white,
    minHeight: '100vh',
  },
  heading_section: {
    paddingTop: 140,
    paddingBottom: 50,
    backgroundColor: '#f9f9f9',
  },
  heading: {
    marginBottom: 0,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  container: {
    padding: `80px 15px ${Theme.footer.height}px`,
    backgroundColor: Theme.white,

    ':not(.a) > p': {
      fontFamily: Theme.font_family_primary,
      fontSize: 16,
      lineHeight: 1.72,
      textAlign: 'left',
      color: '#000e1f',
      marginBottom: 20,

      [Theme.mobile_query]: {
        padding: '0 20px',
        fontSize: 15,
      },
    },
    ':not(.a) > h1': {
      margin: '25px 0px',
      fontSize: 28,
      fontWeight: 'bold',
    },
    ':not(.a) > h2': {
      margin: '25px 0px',
      fontSize: 25,
      fontWeight: 'bold',
    },
    ':not(.a) > h3': {
      margin: '25px 0px',
      fontSize: 22,
      fontWeight: 'bold',
    },
    ':not(.a) > strong': {
      fontWeight: 'bold',
    },
    ':not(.a) > small': {
      margin: '25px 0px',
      fontSize: 14,
      fontWeight: 'bold',
    },
    ':not(.a) > em': {
      margin: '25px 0px',
      fontStyle: 'italic',
    },
    ':not(.a) > img': {
      margin: '25px 0px',
    },
  },
  content: {
    maxWidth: 750,
    margin: '0 auto 20px',
  },
  title: {
    marginBottom: 24,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'left',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Privacy);



// WEBPACK FOOTER //
// ./src/views/Privacy/index.js